import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=8b05baea&scoped=true"
import script from "./TagSelect.vue?vue&type=script&lang=js"
export * from "./TagSelect.vue?vue&type=script&lang=js"
import style0 from "./TagSelect.vue?vue&type=style&index=0&id=8b05baea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b05baea",
  null
  
)

export default component.exports